import { Component, Renderer2, ElementRef } from '@angular/core';
export class TdDataTableTableComponent {
/**
 * @param {?} _elementRef
 * @param {?} _renderer
 */
constructor(private _elementRef: ElementRef,
private _renderer: Renderer2) {
    this._renderer.addClass(this._elementRef.nativeElement, 'td-data-table');
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  /* tslint:disable-next-line */
  selector: 'table[td-data-table]',
  styleUrls: ['./data-table-table.component.css' ],
  templateUrl: './data-table-table.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
}

function TdDataTableTableComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdDataTableTableComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDataTableTableComponent.ctorParameters;
/** @type {?} */
TdDataTableTableComponent.prototype._elementRef;
/** @type {?} */
TdDataTableTableComponent.prototype._renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
